import Body from "./body";
import { BaseAPIModel } from "@weezevent/weezjs-core";
import invariant from "invariant";
const SUBJECT_PREFIX = "{{PREFIX}}";

/**
 * The new Template used for the mail campaigns with PatV2
 * @param {string} subject - Subject of the mail
 */

export default class Template extends BaseAPIModel {

	constructor({
		id,
		body,
		name,
		preview_url: previewUrl,
		brand_kit: brandKit
	}) {
		super({ id, body, name, preview_url: previewUrl });
		this._id = id;
		this._bodyList = body ? body.map(body => new Body(body)) : [];
		this._name = name || "";
		this._previewUrl = previewUrl || "";
		this._brand_kit = brandKit || null;
	}

	static listUrl({ organizationId }) {
		invariant(organizationId != null, "[Model][Template] organizationId is mandatory");
		return `/target/organizations/${organizationId}/templates`;
	}

	fields() {
		return {
			id: { readOnly: true, primaryKey: true },
			bodyList: {},
			name: {},
			previewUrl: { readOnly: true },
		};
	}

	getKey() {
		return String(this._id);
	}

	getBodyID() {
		return this._bodyList[0].getId();
	}

	getDefaultBody() {
		return this._bodyList[0];
	}

	getBodyList() {
		return this._bodyList;
	}

	getURL() {
		return this._previewUrl;
	}

	getDefaultLang() {
		return this._bodyList[0].getLang() || 'fr_FR';
	}

	getBodyByLang(lang) {
		if (lang === 'fr_FR') {
			return this._bodyList.find(b => b.getLang() === lang) || this._bodyList.find(b => b.getLang() == null);
		} else {
			return this._bodyList.find(b => b.getLang() === lang);
		}
	}

	getPreviewURL() {
		return `${window.weezConfig.yuga}/${this._previewUrl}?${(new Date()).getTime()}`;
	}

	isWeezevent(){
		// Check if template is Weezevent Generic
		const url = this.getURL().split('/');

		return url[url.length - 3] === "0" || url[url.length - 3] === "00";
	}

	getUnlayerDesign(index= 0) {
		return this._bodyList[index].getUnlayerDesign();
	}

	getHTML() {
		return this._bodyList[0].getHTML();

	}

	getId() {
		return this._id;
	}

	getName() {
		// When the Name starts with the prefix, hide it
		if (this._name.indexOf(SUBJECT_PREFIX) === 0) {
			this._name = this._name.slice(SUBJECT_PREFIX.length);
		}
		return this._name;
	}

	getBrandKit() {
		return this._brand_kit ?? null;
	}

	getSubject() {
		// For the sample feature, we add {{PREFIX}} at the start of the
		// subject. When we display the subject to the user, this prefix
		// is hidden
		let subject = this.getRawSubject();

		// When the subject starts with the prefix, hide it
		if (subject.indexOf(SUBJECT_PREFIX) === 0) {
			subject = subject.slice(SUBJECT_PREFIX.length);
		}
		return subject;
	}

	getRawSubject() {
		// The original subject
		return this._bodyList[0].getRawSubject() || '';
	}

	toString() {
		return this.getSubject();
	}
}
